import { render, staticRenderFns } from "./FrogLayout.vue?vue&type=template&id=d56dd2e8&scoped=true&"
import script from "./FrogLayout.vue?vue&type=script&lang=js&"
export * from "./FrogLayout.vue?vue&type=script&lang=js&"
import style0 from "./FrogLayout.vue?vue&type=style&index=0&id=d56dd2e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d56dd2e8",
  null
  
)

export default component.exports